import dynamic from 'next/dynamic';

const SubscriptionContractsListContent = dynamic(() =>
  import('./SubscriptionContractsListContent')
);

export { SubscriptionContractsListContent };
